import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _Date$now from "@babel/runtime-corejs2/core-js/date/now";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/destructuring-assignment */
import ReactCrop, { makeAspectCrop } from 'react-image-crop';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import axios from 'axios';
import React, { Fragment } from 'react';
import { cropperBorder } from '@dmi-mch/utils';
import { Button } from '@mch-group/uikit-components';
import Modal from './Modal'; // TODO: IT'S ONLY USED HERE, BUT NICE TO HAVE AS A SEPARATED COMPONENT

var cloudinaryUpload = function cloudinaryUpload(file, preset, cloudinaryObj) {
  var formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', preset);
  formData.append('api_key', cloudinaryObj.apiKey);
  formData.append('timestamp', _Date$now() / 1000);
  cloudinaryObj.tags && formData.append('tags', cloudinaryObj.tags);
  return axios.post("https://api.cloudinary.com/v1_1/".concat(cloudinaryObj.name, "/image/upload"), formData, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  });
};

var ImageCropperModal = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageCropperModal, _React$Component);

  var _super = _createSuper(ImageCropperModal);

  function ImageCropperModal() {
    var _this;

    _classCallCheck(this, ImageCropperModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", _objectSpread({}, _this.defaultState));

    _defineProperty(_assertThisInitialized(_this), "defaultState", {
      open: null,
      cloudinary: null,
      crop: {
        x: 0,
        y: 0,
        aspect: 1.6,
        width: 0,
        height: 0
      },
      pixelCrop: {},
      processing: false
    });

    _defineProperty(_assertThisInitialized(_this), "onConfirmCrop", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                processing: true
              });

              cloudinaryUpload(_this.props.file, _this.props.configuration.uploadPreset.mfpFeProfileImage, _this.props.cloudinary).then(function (response) {
                var data = response.data;
                var _this$state$pixelCrop = _this.state.pixelCrop,
                    x = _this$state$pixelCrop.x,
                    y = _this$state$pixelCrop.y,
                    width = _this$state$pixelCrop.width,
                    height = _this$state$pixelCrop.height;
                var _this$props = _this.props,
                    resizeWidth = _this$props.resizeWidth,
                    resizeHeight = _this$props.resizeHeight;
                var resizeParams = [];
                resizeWidth && resizeParams.push("w_".concat(resizeWidth));
                resizeHeight && resizeParams.push("h_".concat(resizeHeight));

                if (resizeWidth || resizeHeight) {
                  resizeParams = "/".concat(resizeParams.join(','));
                } else {
                  resizeParams = '';
                }

                var cropParams = "/x_".concat(x, ",y_").concat(y, ",c_crop,w_").concat(width, ",h_").concat(height);
                var CLOUDINARY_NAME = _this.props.cloudinary.name;
                var imageUrl = "https://res.cloudinary.com/".concat(CLOUDINARY_NAME, "/image/upload").concat(cropParams).concat(resizeParams) + "/v".concat(data.version, "/").concat(data.public_id, ".").concat(data.format);
                axios.get(imageUrl, {
                  responseType: 'blob'
                }).then(function (imageContent) {
                  return imageContent.data;
                }).then(function (blob) {
                  _this.props.onCropConfirmed({
                    url: imageUrl,
                    blob: blob
                  });
                }).then(function () {
                  _this.setState(_objectSpread({}, _this.defaultState));
                });
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onModalClose", function () {
      _this.setState(_objectSpread({}, _this.defaultState));
    });

    return _this;
  }

  _createClass(ImageCropperModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        open: this.props.open
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var state = this.state,
          props = this.props,
          onModalClose = this.onModalClose,
          onConfirmCrop = this.onConfirmCrop;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Modal, {
        center: true,
        open: state.open,
        onClose: onModalClose,
        closeOnEscape: false,
        closeOnDimmerClick: false
      }, /*#__PURE__*/React.createElement("div", {
        className: props.className
      }, props.fileUrl && /*#__PURE__*/React.createElement(ReactCrop, {
        src: props.fileUrl,
        onChange: function onChange(crop, pixelCrop) {
          _this2.setState({
            crop: crop,
            pixelCrop: pixelCrop
          });
        },
        onImageLoaded: function onImageLoaded(image) {
          var crop = makeAspectCrop(props.cropProperties, image.width / image.height);

          _this2.setState({
            crop: crop,
            pixelCrop: {
              x: Math.round(image.naturalWidth * (crop.x / 100)),
              y: Math.round(image.naturalHeight * (crop.y / 100)),
              width: Math.round(image.naturalWidth * (crop.width / 100)),
              height: Math.round(image.naturalHeight * (crop.height / 100))
            }
          });
        },
        keepSelection: true,
        crop: state.crop
      })), /*#__PURE__*/React.createElement("div", {
        className: "mt-5"
      }, /*#__PURE__*/React.createElement(Button, {
        className: "me-3",
        onClick: onModalClose,
        size: "small"
      }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
        primary: true,
        onClick: onConfirmCrop,
        disabled: state.crop && (state.crop.width === 0 || state.crop.height === 0 || state.processing),
        loading: state.processing,
        size: "small"
      }, "Confirm"))));
    }
  }]);

  return ImageCropperModal;
}(React.Component); // These styles are copied from the ReactCrop component, no 'modification' here


_defineProperty(ImageCropperModal, "propTypes", {
  className: PropTypes.string,
  open: PropTypes.bool.isRequired,
  file: PropTypes.object,
  fileUrl: PropTypes.string,
  resizeWidth: PropTypes.number,
  resizeHeight: PropTypes.number,
  uploadPreset: PropTypes.string.isRequired,
  onCropConfirmed: PropTypes.func,
  labels: PropTypes.object,
  cloudinary: PropTypes.object,
  cropProperties: PropTypes.object,
  configuration: PropTypes.object
});

export default styled(ImageCropperModal).withConfig({
  displayName: "ImageCropper",
  componentId: "sc-w9u669-0"
})(["display:flex !important;align-items:center;justify-content:center;.ReactCrop{position:relative;display:inline-block;cursor:crosshair;overflow:hidden;max-width:100%;background-color:#000;}.ReactCrop:focus{outline:none;}.ReactCrop--disabled,.ReactCrop--locked{cursor:inherit;}.ReactCrop__image{display:block;max-width:100%;}.ReactCrop--crop-invisible .ReactCrop__image{opacity:0.5;}.ReactCrop__crop-selection{position:absolute;top:0;left:0;transform:translate3d(0,0,0);box-sizing:border-box;cursor:move;box-shadow:0 0 0 9999em rgba(0,0,0,0.5);border:1px solid;border-image-source:url(", ");border-image-slice:1;border-image-repeat:repeat;}.ReactCrop--disabled .ReactCrop__crop-selection{cursor:inherit;}.ReactCrop__drag-handle{position:absolute;width:9px;height:9px;background-color:rgba(0,0,0,0.2);border:1px solid rgba(255,255,255,0.7);box-sizing:border-box;outline:1px solid transparent;}.ReactCrop .ord-nw{top:0;left:0;margin-top:-5px;margin-left:-5px;cursor:nw-resize;}.ReactCrop .ord-n{top:0;left:50%;margin-top:-5px;margin-left:-5px;cursor:n-resize;}.ReactCrop .ord-ne{top:0;right:0;margin-top:-5px;margin-right:-5px;cursor:ne-resize;}.ReactCrop .ord-e{top:50%;right:0;margin-top:-5px;margin-right:-5px;cursor:e-resize;}.ReactCrop .ord-se{bottom:0;right:0;margin-bottom:-5px;margin-right:-5px;cursor:se-resize;}.ReactCrop .ord-s{bottom:0;left:50%;margin-bottom:-5px;margin-left:-5px;cursor:s-resize;}.ReactCrop .ord-sw{bottom:0;left:0;margin-bottom:-5px;margin-left:-5px;cursor:sw-resize;}.ReactCrop .ord-w{top:50%;left:0;margin-top:-5px;margin-left:-5px;cursor:w-resize;}.ReactCrop__disabled .ReactCrop__drag-handle{cursor:inherit;}.ReactCrop__drag-bar{position:absolute;}.ReactCrop__drag-bar.ord-n{top:0;left:0;width:100%;height:6px;margin-top:-3px;}.ReactCrop__drag-bar.ord-e{right:0;top:0;width:6px;height:100%;margin-right:-3px;}.ReactCrop__drag-bar.ord-s{bottom:0;left:0;width:100%;height:6px;margin-bottom:-3px;}.ReactCrop__drag-bar.ord-w{top:0;left:0;width:6px;height:100%;margin-left:-3px;}.ReactCrop--new-crop .ReactCrop__drag-bar,.ReactCrop--new-crop .ReactCrop__drag-handle,.ReactCrop--fixed-aspect .ReactCrop__drag-bar{display:none;}.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n,.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e,.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s,.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w{display:none;}@media (max-width:768px),(pointer:coarse){.ReactCrop__drag-handle{width:17px;height:17px;}.ReactCrop .ord-nw{margin-top:-9px;margin-left:-9px;}.ReactCrop .ord-n{margin-top:-9px;margin-left:-9px;}.ReactCrop .ord-ne{margin-top:-9px;margin-right:-9px;}.ReactCrop .ord-e{margin-top:-9px;margin-right:-9px;}.ReactCrop .ord-se{margin-bottom:-9px;margin-right:-9px;}.ReactCrop .ord-s{margin-bottom:-9px;margin-left:-9px;}.ReactCrop .ord-sw{margin-bottom:-9px;margin-left:-9px;}.ReactCrop .ord-w{margin-top:-9px;margin-left:-9px;}.ReactCrop__drag-bar.ord-n{height:14px;margin-top:-7px;}.ReactCrop__drag-bar.ord-e{width:14px;margin-right:-7px;}.ReactCrop__drag-bar.ord-s{height:14px;margin-bottom:-7px;}.ReactCrop__drag-bar.ord-w{width:14px;margin-left:-7px;}}"], cropperBorder);